module.exports = __webpack_public_path__ + "static/media/1016864.955d3fbb.jpg";